import { useEffect, useState } from 'react';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';
import { InvoiceService as Service, InvoiceService } from '../InvoiceService';

import { useForm } from '../../../shared/hooks/Form';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { AppStorage } from '../../../service/UserStorage';
import { ToastService } from '../../../AppToast';

const validateTaxCode = value => {
  let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
  if (value.length > 10) {
    patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
  }
  if (value === "") return true;
  if (patt.test(value) === false) {
    return false;
  }
  const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
    + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
    + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

  return (10 - number % 11) === Number(value.charAt(9));
}

export const DialogSelectInvoiceDiscounted = (props) => {

  const { display, setDisplay, addSelectedItems, selectionMode, invoiceStatus, sendTaxStatus = '2,4', perPageOptions, registerInvoice } = props;

  const [invoiceSerials, setInvoiceSerials] = useState([]);

  const [requiredParams, setRequiredParams] = useState(null);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(({ items }) => {
      const _invoiceSerials = [];
      items.forEach(item => {
        _invoiceSerials.push({ value: item.symbolCode, label: item.symbolCode });
      });
      setInvoiceSerials(_invoiceSerials);
    });

  }, []);

  const { render: renderForm, setValue, getValue } = useForm({
    fields: [
      { field: 'invoiceSerial', header: 'Ký hiệu', type: 'Dropdown', DropdownProps: { options: invoiceSerials, filter: true, resetFilterOnHide: true }, className: 'md:col-3', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'fromDate', header: 'Từ ngày', type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      { field: 'toDate', header: 'Đến ngày', type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      { field: 'buyerTaxCode', header: 'Mã số thuế', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8', }
    ],
    layout: 'Horizontal'
  });

  const search = () => {
    const searchValue = getValue();
    console.log("🚀 ~ search ~ searchValue.buyerTaxCode:", searchValue.buyerTaxCode)
    if (!validateTaxCode(searchValue.buyerTaxCode || '')) {
      return ToastService.error('Mã số thuế không hợp lệ');
    }
    if (invoiceStatus) {
      searchValue.invoiceStatus = invoiceStatus;
    }
    if (sendTaxStatus) {
      searchValue.sendTaxStatus = sendTaxStatus;
    }
    setRequiredParams(searchValue);
  }

  const { render: renderDataTable, selectedItems, clearItems } = useDataTable({
    header: '',
    dataKey: 'id',
    columns: [
      {
        field: 'invoiceStatus', header: 'Trạng thái', width: 110, matchMode: 'contains', filterType: 'dropdown', filterOptions: Service.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
          return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{Service.invoiceStatuses[rowData.invoiceStatus]?.label}</span>;
        }
      },
      { field: 'invoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains' },
      { field: 'invoiceDate', header: 'Ngày hoá đơn', width: 110, dataType: 'date' },
      { field: 'invoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains' },
      {
        field: 'buyerLegalName', header: 'Tên đơn vị/Tên người mua', minWidth: 250, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      { field: 'buyerTaxCode', header: 'Mã số thuế', width: 110, matchMode: 'contains' },
      { field: 'taxAuthorityCode', header: 'Mã cơ quan thuế', width: 150, matchMode: 'contains' }
    ],
    heightCalc: 350,
    requiredParams,
    getList: (params) => {
      const { mst, ...filteredParams } = params; // Remove the 'mst' field from params
      return InvoiceService.getList({ ...filteredParams, loadAll: true });
    },
    selectionMode: 'checkbox',
  });

  useEffect(() => {
    if (display) {
      setValue({
        invoiceSerial: registerInvoice.symbolCode,
        invoiceNumber: '',
        fromDate: null,
        toDate: null,
        buyerTaxCode: ''
      });
      clearItems();
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {
    if (!selectedItems) {
      return ToastService.error('Chưa chọn hóa đơn');
    }
    addSelectedItems(selectedItems);
  }

  return (
    <Dialog
      header="Chọn hoá đơn"
      visible={display}
      style={{ width: '90rem' }}
      draggable={false}
      resizable={true}
      position="top"
      onHide={() => setDisplay(false)}
    >
      <div className="grid">
        <div className="col-11">
          {renderForm()}
        </div>
        <div className="col-1">
          <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={search} />
        </div>
        <div className="col-12">
          {renderDataTable()}
        </div>
      </div>

      <div className="flex justify-content-end">
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
        <Button label="Nhận" icon="pi pi-check" onClick={handleSubmit} className="p-button-sm" />
      </div>
    </Dialog>
  );
}